import { render, staticRenderFns } from "./people_index.vue?vue&type=template&id=69536606&scoped=true&"
import script from "./people_index.vue?vue&type=script&lang=js&"
export * from "./people_index.vue?vue&type=script&lang=js&"
import style0 from "./people_index.vue?vue&type=style&index=0&id=69536606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69536606",
  null
  
)

component.options.__file = "people_index.vue"
export default component.exports